import { GitHub, LinkedIn } from "@mui/icons-material";
import { Typography, Link } from "@mui/material";
import { CV } from "@api/Models";

interface HeaderProps {
  cv: CV;
}

export function Header({ cv }: HeaderProps) {
  return (
    <header className="mb-8">
      <Typography variant="h2" className="text-xl font-bold mb-2">
        {cv.name}
      </Typography>
      <div className="flex space-x-4 mb-4">
        <Link href={cv.links.LinkedIn} className="flex items-center text-blue-600">
          <LinkedIn className="w-5 h-5 mr-1" />
          LinkedIn
        </Link>
        <Link href={cv.links.Github} className="flex items-center text-gray-800">
          <GitHub className="w-5 h-5 mr-1" />
          GitHub
        </Link>
      </div>
      <br />
      <Typography variant="body1" className="text-gray-600">
        {cv.about_me}
      </Typography>
    </header>
  );
}
